import { getConfiguredTenantCode } from '@/config/tenant-site'
import { tenantParticipationUrl } from '@/config/site-mode'

/** catalog 条目跳转：同租户 → 本域路径；跨租户 → 源租户站 */
export function catalogParticipationHref(
  tenantCode: string | undefined,
  path: string,
  currentTenantCode?: string | null,
): string {
  const code = tenantCode?.trim()
  const current = (currentTenantCode ?? getConfiguredTenantCode()).trim()

  if (code && current && code.toLowerCase() === current.toLowerCase()) {
    return path
  }
  if (code) {
    return tenantParticipationUrl(code, path)
  }
  return path
}

export function isExternalParticipationHref(href: string): boolean {
  if (href.startsWith('http://') || href.startsWith('https://')) return true
  if (typeof window !== 'undefined' && href.startsWith('//')) return true
  return false
}
